import { styled } from 'baseui';

export const ErrorMessage = styled('div', {
  color: 'red',
  marginTop: '10px',
  textAlign: 'center',
});

export const AuthButtonContainer = styled('div', {
  marginTop: '20px',
  width: '100%',
});

export const AuthLinkContainer = styled('div', {
  marginTop: '20px',
  textAlign: 'center',
});
